const toRGB = color => {
  if (Array.isArray(color)) return color
  if (color && color.startsWith('#')) {
    const str = color.slice(1)
    const n = 3 === str.length ? 1 : 6 === str.length ? 2 : 0
    if (n > 0) {
      const arr = str.match(new RegExp(`.{1,${n}}`, 'g'))
      return arr.map(v => {
        const hex = 1 === n ? v + v : v
        return parseInt(hex, 16)
      })
    }
  }
  return [0, 0, 0]
}

const toColor = rgb =>
  `#${rgb
    .map(v => {
      const str = v.toString(16)
      return 1 === str.length ? `0${str}` : str
    })
    .reduce((acc, cur) => `${acc}${cur}`, '')}`

const colorBright = (color, percent) => {
  const p = percent >= -1 && percent <= 1 ? percent : 0
  const rgb = toRGB(color).map(v => Math.round(p > 0 ? v + p * (255 - v) : v + p * v))
  return toColor(rgb)
}

const colorSmooth = (color, percent) => {
  const p = percent >= 0 && percent <= 1 ? percent : 0
  const rgb = toRGB(color).map(v => Math.round(v + p * (127 - v)))
  return toColor(rgb)
}

const colorLight = (color, percent) => {
  const p = percent >= -1 && percent <= 1 ? percent : 0
  const s = Math.round(255 * p)
  const rgb = toRGB(color).map(v => {
    const n = v + s
    return n < 0 ? 0 : n > 255 ? 255 : n
  })
  return toColor(rgb)
}

const getPattern = (id, color) => {
  return {
    id: id,
    path: {
      d: 'M -4 4 L 4 -4 M 0 16 L 16 0 M 12 20 L 20 12',
      stroke: colorBright(color, 0.5),
      strokeWidth: 7,
      fill: colorSmooth(color, 0.5)
    },
    width: 16,
    height: 16
  }
}

// const initialColors = ['#10a3a1', '#2978c3', '#34359c', '#755697', '#912b93', '#a2306c', '#a11551']
const initialColors = ['#C1272D', '#F7931E', '#8CC63F', '#29ABE2', '#1C67AA', '#9E005D', '#223D64']

const defaultColors = []
const defaultPatterns = []

let cIndex = 0
;[0, 0.2, 0.4].forEach(percent => {
  initialColors.forEach(color => {
    const newColor = colorLight(color, percent)
    defaultColors.push(newColor)
    defaultPatterns.push(getPattern(`hatch-${cIndex++}`, newColor))
  })
})

export { defaultPatterns, defaultColors, initialColors, colorBright, colorLight, colorSmooth }
